webpackJsonp([1],{

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



var formatter = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  minimumFractionDigits: 2
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function (value) {
  return formatter.format(value);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('date', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format('YYYY-MM-DD');
  }
  return '';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('state', function (value) {
  if (value === 'realized') {
    return 'Zrealizowane';
  }
  if (value === 'new') {
    return 'Nowe';
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(20);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = "https://gieldakaliska.pl/";

// xdebug
// Vue.http.interceptors.push((request, next) => {
//   request.params.XDEBUG_SESSION_START = 'PHPSTORM'
//   next()
// })

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (req, next) {
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* START_LOADING */]);
  if (__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].hasToken()) {
    req.headers.set('Authorization', 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].getToken());
  }
  if (req.url.includes('api') && !(req.url.includes('api/login_check') || req.url.includes('api/token/refresh'))) {
    req.headers.set('Content-Type', 'application/json');
    req.headers.set('Accept', 'application/json');
  }
  next(function (res) {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* STOP_LOADING */]);
    if (res.status === 404) {
      window.alert('Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d, nie odnaleziono obiektu pod adresem ' + res.url + ' - skontaktuj si\u0119 z administratorem');
    }
    if (res.status === 500) {
      window.alert('Wystąpił nieoczekiwany błąd aplikacji, skontaktuj się z administratorem');
    }
    if (res.status === 401 && !(req.url.includes('api/login_check') || req.url.includes('api/token/refresh'))) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('api/token/refresh', {
        refresh_token: __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].getRefreshToken()
      }).then(function (_ref) {
        var body = _ref.body;

        __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].setToken(body.token);
        __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].setRefreshToken(body.refresh_token);
        return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http[req.method.toLowerCase()](req.url, req.body);
      }, function () {
        __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].removeAuthData();
        window.location.reload();
      });
    }
  });
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Records_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Records_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Records_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RecordEdit_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RecordEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_RecordEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RecordsList_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RecordsList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_RecordsList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth__ = __webpack_require__(19);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function requireAuth(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */].hasToken()) {
    next({
      name: 'Login'
    });
  } else {
    next();
  }
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    name: 'Home',
    path: '/',
    redirect: function redirect() {
      return {
        name: 'Records',
        params: {
          slug: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD')
        }
      };
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Login_vue___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_7__auth__["a" /* default */].hasToken()) {
        next({
          path: '/'
        });
      } else {
        next();
      }
    }
  }, {
    path: '/records/:slug/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Records_vue___default.a,
    props: true,
    beforeEnter: requireAuth,
    children: [{
      path: '',
      name: 'Records',
      component: __WEBPACK_IMPORTED_MODULE_4__components_RecordsList_vue___default.a,
      props: true,
      beforeEnter: requireAuth
    }, {
      path: ':id/edit',
      name: 'RecordEdit',
      component: __WEBPACK_IMPORTED_MODULE_3__components_RecordEdit_vue___default.a,
      props: true,
      beforeEnter: requireAuth
    }]
  }]
}));

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(266),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterZeroPrices; });
var filterZeroPrices = function filterZeroPrices(prices) {
  if (prices.length === 1 && parseFloat(prices[0].price) < 1) {
    return prices;
  }
  return prices.filter(function (_ref) {
    var price = _ref.price;
    return parseFloat(price) > 0;
  });
};

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_lite__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_design_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_design_lite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_focus__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_focus__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', __WEBPACK_IMPORTED_MODULE_7_vue_focus__["focus"]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  },
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_mdl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_mdl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_mdl__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MdlSnackbar: __WEBPACK_IMPORTED_MODULE_0_vue_mdl__["MdlSnackbar"]
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_accounting__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { type: String, required: true },
    disabled: { type: Boolean }
  },
  directives: {
    focus: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  data: function data() {
    return {
      error: false
    };
  },

  computed: {
    formattedValue: function formattedValue() {
      return Number(__WEBPACK_IMPORTED_MODULE_0_accounting___default.a.formatMoney(this.value.replace(',', '.'), '', 2, ' ', '.')).toFixed(2);
    }
  },
  methods: {
    update: function update(event) {
      var newValue = __WEBPACK_IMPORTED_MODULE_0_accounting___default.a.formatMoney(event.target.value.replace(',', '.'), '', 2, ' ', '.');
      if (newValue !== this.value) {
        this.$emit('input', newValue);
      } else {
        event.target.value = this.formattedValue;
      }
    }
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: { type: String, required: true },
    stacked: { type: Boolean, required: false, default: false }
  },
  computed: {
    hasAddon: function hasAddon() {
      return !!this.$slots.addon;
    },
    horizontal: function horizontal() {
      return !this.stacked;
    }
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormGroup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TextInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_mdl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_mdl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_mdl__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      logging: false,
      email: '',
      password: '',
      error: ''
    };
  },

  components: {
    CenterHeader: __WEBPACK_IMPORTED_MODULE_0__CenterHeader_vue___default.a,
    FormGroup: __WEBPACK_IMPORTED_MODULE_1__FormGroup_vue___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_2__TextInput_vue___default.a,
    Logo: __WEBPACK_IMPORTED_MODULE_4__Logo_vue___default.a,
    MdlTextfield: __WEBPACK_IMPORTED_MODULE_5_vue_mdl__["MdlTextfield"],
    MdlButton: __WEBPACK_IMPORTED_MODULE_5_vue_mdl__["MdlButton"]
  },
  methods: {
    submit: function submit() {
      var _this = this;

      this.logging = true;
      __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].login(this.email, this.password).then(this.loginSuccess, this.loginError).then(function () {
        _this.logging = false;
      });
    },
    loginSuccess: function loginSuccess() {
      window.location.reload();
    },
    loginError: function loginError(message) {
      this.$root.$emit('flash', { message: message });
    }
  }
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_mdl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_mdl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_mdl__);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MdlSpinner: __WEBPACK_IMPORTED_MODULE_0_vue_mdl__["MdlSpinner"]
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MySpinner_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MySpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MySpinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CurrencyInput_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CurrencyInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CurrencyInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    slug: { type: String, required: true },
    id: { type: [Number, String], required: true }
  },
  components: {
    MySpinner: __WEBPACK_IMPORTED_MODULE_1__MySpinner_vue___default.a,
    CurrencyInput: __WEBPACK_IMPORTED_MODULE_2__CurrencyInput_vue___default.a
  },
  computed: {
    record: function record() {
      return this.$store.getters.getRecordBy(this.slug, this.id);
    }
  },
  methods: {
    addDraftPrice: function addDraftPrice(record) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* ADD_DRAFT_PRICE */], record);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* RECORD_CHANGED */], this.record);
    },
    removeDraftPrice: function removeDraftPrice(record, index) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* REMOVE_DRAFT_PRICE */], { record: record, index: index });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* RECORD_CHANGED */], this.record);
    },
    priceChanged: function priceChanged() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* RECORD_CHANGED */], this.record);
    },
    usePreviousPrices: function usePreviousPrices() {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_PREVIOUS_PRICES */], { record: this.record, previousPrices: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.record.previousPrices)) });
    }
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_mdl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_mdl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_mdl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MySpinner_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MySpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MySpinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types__ = __webpack_require__(34);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    slug: { type: String, required: true }
  },
  components: {
    MdlSelect: __WEBPACK_IMPORTED_MODULE_3_vue_mdl__["MdlSelect"],
    MdlSpinner: __WEBPACK_IMPORTED_MODULE_3_vue_mdl__["MdlSpinner"],
    MySpinner: __WEBPACK_IMPORTED_MODULE_4__MySpinner_vue___default.a
  },
  data: function data() {
    return {
      search: '',
      connectionStatus: 'online',
      searchFocus: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['updating', 'thereAreChangedRecordsFor']), {
    offline: function offline() {
      return this.connectionStatus === 'offline';
    },
    filteredCardRecords: function filteredCardRecords() {
      var _this = this;

      return this.card.records.filter(function (r) {
        return r.product.name.toLowerCase().includes(_this.search.toLowerCase());
      });
    },
    card: function card() {
      return this.$store.getters.getCardBy(this.slug);
    },
    days: function days() {
      var days = [];
      for (var i = 0; i <= 7; i++) {
        var day = __WEBPACK_IMPORTED_MODULE_1_moment___default()().locale('pl').subtract(i, 'days');
        days.push({
          name: day.format('DD-MM-YYYY (ddd)'),
          value: day.format('YYYY-MM-DD')
        });
      }
      return days;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    clearSearch: function clearSearch() {
      this.searchFocus = true;
      this.search = '';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])({
    'fetchData': __WEBPACK_IMPORTED_MODULE_5__action_types__["a" /* FETCH_CARD */]
  }), {
    updateCard: function updateCard(card) {
      var _this2 = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__action_types__["b" /* UPDATE_CARD */], card).then(function () {
        _this2.$root.$emit('flash', { message: 'Notowania zostały wysłane poprawnie' });
      }, function () {
        _this2.$root.$emit('flash', { message: 'Wystąpił błąd podczas wysyłania notowań, skontaktuj się z administratorem' });
      });
    },
    networkChange: function networkChange(e) {
      this.connectionStatus = e.type;
    },

    hideMenu: function hideMenu() {
      document.getElementsByClassName('mdl-layout__drawer')[0].classList.remove('is-visible');
      document.getElementsByClassName('mdl-layout__obfuscator')[0].classList.remove('is-visible');
    },
    getRouteToEdit: function getRouteToEdit(record) {
      return {
        name: 'RecordEdit',
        params: {
          id: record.id
        }
      };
    },
    goToDay: function goToDay(slug) {
      this.$router.push({
        name: 'Records',
        params: {
          slug: slug
        }
      });
    },
    fetchWhenNeed: function fetchWhenNeed() {
      if (!this.card) {
        this.fetchData(this.slug);
      }
    },
    goToEdit: function goToEdit(record) {
      this.$router.push({
        name: 'RecordEdit',
        params: {
          id: record.id
        }
      });
    }
  }),
  watch: {
    '$route': 'fetchWhenNeed'
  },
  created: function created() {
    this.fetchWhenNeed();
    window.removeEventListener('online', this.networkChange);
    window.addEventListener('online', this.networkChange);
    window.removeEventListener('offline', this.networkChange);
    window.addEventListener('offline', this.networkChange);
  },
  mounted: function mounted() {
    var that = this;
    setTimeout(function () {
      var button = document.getElementsByClassName('mdl-layout__drawer-button')[0];
      if (button) {
        button.addEventListener('click', function () {
          that.searchFocus = true;
        });
      }
    }, 100);
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MySpinner_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MySpinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MySpinner_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    slug: { type: String, required: true }
  },
  components: {
    MySpinner: __WEBPACK_IMPORTED_MODULE_0__MySpinner_vue___default.a
  },
  computed: {
    card: function card() {
      return this.$store.getters.getCardBy(this.slug);
    }
  },
  methods: {
    goToEdit: function goToEdit(record) {
      this.$router.push({
        name: 'RecordEdit',
        params: {
          id: record.id
        }
      });
    }
  }
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: { type: String, required: true }
  }
});

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(35);




var TOKEN = 'token';
var REFRESH_TOKEN = 'refresh_token';
var EMAIL = 'email';
var ROLES = 'roles';

/* harmony default export */ __webpack_exports__["a"] = ({
  removeAuthData: function removeAuthData() {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(TOKEN);
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(REFRESH_TOKEN);
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(EMAIL);
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.remove(ROLES);
  },
  hasToken: function hasToken() {
    return !!__WEBPACK_IMPORTED_MODULE_1_store___default.a.get(TOKEN);
  },
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(TOKEN);
  },
  hasRefreshToken: function hasRefreshToken() {
    return !!__WEBPACK_IMPORTED_MODULE_1_store___default.a.get(REFRESH_TOKEN);
  },
  getRefreshToken: function getRefreshToken() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(REFRESH_TOKEN);
  },
  setRefreshToken: function setRefreshToken(token) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(REFRESH_TOKEN, token);
  },
  setToken: function setToken(token) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(TOKEN, token);
  },
  setEmail: function setEmail(email) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(EMAIL, email);
  },
  setRoles: function setRoles(roles) {
    __WEBPACK_IMPORTED_MODULE_1_store___default.a.set(ROLES, roles);
  },
  getEmail: function getEmail() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(EMAIL);
  },
  getRoles: function getRoles() {
    return __WEBPACK_IMPORTED_MODULE_1_store___default.a.get(ROLES);
  },
  login: function login(username, password) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].auth.login(username, password).then(function (_ref) {
        var body = _ref.body;

        if (_this.isNoAdmin(body.roles)) {
          _this.removeAuthData();
          reject('Użytkownik nie posiada uprawnień administratora');
        } else {
          _this.setToken(body.token);
          _this.setRefreshToken(body.refresh_token);
          _this.setEmail(body.email);
          _this.setRoles(body.roles);
          resolve();
        }
      }, function () {
        return reject('Nie udało się zalogować');
      });
    });
  },
  logout: function logout() {
    this.removeAuthData();
  },
  isNoAdmin: function isNoAdmin(roles) {
    return !(roles.includes('ROLE_ADMIN') || roles.includes('ROLE_SUPER_ADMIN'));
  }
});

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STOP_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return START_UPDATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return STOP_UPDATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADD_DRAFT_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REMOVE_DRAFT_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RECORD_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PREVIOUS_PRICES; });
var START_LOADING = 'START_LOADING';
var STOP_LOADING = 'STOP_LOADING';
var START_UPDATING = 'START_UPDATING';
var STOP_UPDATING = 'STOP_UPDATING';
var ADD_CARD = 'ADD_CARD';
var UPDATE_CARD = 'UPDATE_CARD';
var ADD_DRAFT_PRICE = 'ADD_DRAFT_PRICE';
var REMOVE_DRAFT_PRICE = 'REMOVE_DRAFT_PRICE';
var RECORD_CHANGED = 'RECORD_CHANGED';
var SET_PREVIOUS_PRICES = 'SET_PREVIOUS_PRICES';

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 54,
	"./af.js": 54,
	"./ar": 61,
	"./ar-dz": 55,
	"./ar-dz.js": 55,
	"./ar-kw": 56,
	"./ar-kw.js": 56,
	"./ar-ly": 57,
	"./ar-ly.js": 57,
	"./ar-ma": 58,
	"./ar-ma.js": 58,
	"./ar-sa": 59,
	"./ar-sa.js": 59,
	"./ar-tn": 60,
	"./ar-tn.js": 60,
	"./ar.js": 61,
	"./az": 62,
	"./az.js": 62,
	"./be": 63,
	"./be.js": 63,
	"./bg": 64,
	"./bg.js": 64,
	"./bn": 65,
	"./bn.js": 65,
	"./bo": 66,
	"./bo.js": 66,
	"./br": 67,
	"./br.js": 67,
	"./bs": 68,
	"./bs.js": 68,
	"./ca": 69,
	"./ca.js": 69,
	"./cs": 70,
	"./cs.js": 70,
	"./cv": 71,
	"./cv.js": 71,
	"./cy": 72,
	"./cy.js": 72,
	"./da": 73,
	"./da.js": 73,
	"./de": 76,
	"./de-at": 74,
	"./de-at.js": 74,
	"./de-ch": 75,
	"./de-ch.js": 75,
	"./de.js": 76,
	"./dv": 77,
	"./dv.js": 77,
	"./el": 78,
	"./el.js": 78,
	"./en-au": 79,
	"./en-au.js": 79,
	"./en-ca": 80,
	"./en-ca.js": 80,
	"./en-gb": 81,
	"./en-gb.js": 81,
	"./en-ie": 82,
	"./en-ie.js": 82,
	"./en-nz": 83,
	"./en-nz.js": 83,
	"./eo": 84,
	"./eo.js": 84,
	"./es": 86,
	"./es-do": 85,
	"./es-do.js": 85,
	"./es.js": 86,
	"./et": 87,
	"./et.js": 87,
	"./eu": 88,
	"./eu.js": 88,
	"./fa": 89,
	"./fa.js": 89,
	"./fi": 90,
	"./fi.js": 90,
	"./fo": 91,
	"./fo.js": 91,
	"./fr": 94,
	"./fr-ca": 92,
	"./fr-ca.js": 92,
	"./fr-ch": 93,
	"./fr-ch.js": 93,
	"./fr.js": 94,
	"./fy": 95,
	"./fy.js": 95,
	"./gd": 96,
	"./gd.js": 96,
	"./gl": 97,
	"./gl.js": 97,
	"./gom-latn": 98,
	"./gom-latn.js": 98,
	"./he": 99,
	"./he.js": 99,
	"./hi": 100,
	"./hi.js": 100,
	"./hr": 101,
	"./hr.js": 101,
	"./hu": 102,
	"./hu.js": 102,
	"./hy-am": 103,
	"./hy-am.js": 103,
	"./id": 104,
	"./id.js": 104,
	"./is": 105,
	"./is.js": 105,
	"./it": 106,
	"./it.js": 106,
	"./ja": 107,
	"./ja.js": 107,
	"./jv": 108,
	"./jv.js": 108,
	"./ka": 109,
	"./ka.js": 109,
	"./kk": 110,
	"./kk.js": 110,
	"./km": 111,
	"./km.js": 111,
	"./kn": 112,
	"./kn.js": 112,
	"./ko": 113,
	"./ko.js": 113,
	"./ky": 114,
	"./ky.js": 114,
	"./lb": 115,
	"./lb.js": 115,
	"./lo": 116,
	"./lo.js": 116,
	"./lt": 117,
	"./lt.js": 117,
	"./lv": 118,
	"./lv.js": 118,
	"./me": 119,
	"./me.js": 119,
	"./mi": 120,
	"./mi.js": 120,
	"./mk": 121,
	"./mk.js": 121,
	"./ml": 122,
	"./ml.js": 122,
	"./mr": 123,
	"./mr.js": 123,
	"./ms": 125,
	"./ms-my": 124,
	"./ms-my.js": 124,
	"./ms.js": 125,
	"./my": 126,
	"./my.js": 126,
	"./nb": 127,
	"./nb.js": 127,
	"./ne": 128,
	"./ne.js": 128,
	"./nl": 130,
	"./nl-be": 129,
	"./nl-be.js": 129,
	"./nl.js": 130,
	"./nn": 131,
	"./nn.js": 131,
	"./pa-in": 132,
	"./pa-in.js": 132,
	"./pl": 133,
	"./pl.js": 133,
	"./pt": 135,
	"./pt-br": 134,
	"./pt-br.js": 134,
	"./pt.js": 135,
	"./ro": 136,
	"./ro.js": 136,
	"./ru": 137,
	"./ru.js": 137,
	"./sd": 138,
	"./sd.js": 138,
	"./se": 139,
	"./se.js": 139,
	"./si": 140,
	"./si.js": 140,
	"./sk": 141,
	"./sk.js": 141,
	"./sl": 142,
	"./sl.js": 142,
	"./sq": 143,
	"./sq.js": 143,
	"./sr": 145,
	"./sr-cyrl": 144,
	"./sr-cyrl.js": 144,
	"./sr.js": 145,
	"./ss": 146,
	"./ss.js": 146,
	"./sv": 147,
	"./sv.js": 147,
	"./sw": 148,
	"./sw.js": 148,
	"./ta": 149,
	"./ta.js": 149,
	"./te": 150,
	"./te.js": 150,
	"./tet": 151,
	"./tet.js": 151,
	"./th": 152,
	"./th.js": 152,
	"./tl-ph": 153,
	"./tl-ph.js": 153,
	"./tlh": 154,
	"./tlh.js": 154,
	"./tr": 155,
	"./tr.js": 155,
	"./tzl": 156,
	"./tzl.js": 156,
	"./tzm": 158,
	"./tzm-latn": 157,
	"./tzm-latn.js": 157,
	"./tzm.js": 158,
	"./uk": 159,
	"./uk.js": 159,
	"./ur": 160,
	"./ur.js": 160,
	"./uz": 162,
	"./uz-latn": 161,
	"./uz-latn.js": 161,
	"./uz.js": 162,
	"./vi": 163,
	"./vi.js": 163,
	"./x-pseudo": 164,
	"./x-pseudo.js": 164,
	"./yo": 165,
	"./yo.js": 165,
	"./zh-cn": 166,
	"./zh-cn.js": 166,
	"./zh-hk": 167,
	"./zh-hk.js": 167,
	"./zh-tw": 168,
	"./zh-tw.js": 168
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.930807c.png";

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(265),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(259),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(262),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(268),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 258:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('mdl-spinner', {
    attrs: {
      "single-color": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.record) ? _c('div', {
    staticClass: "mdl-grid"
  }, [_c('h3', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [(_vm.record.changed) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.record.product.name) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "subheader"
  }, [(_vm.record.product.variety) ? [_vm._v(_vm._s(_vm.record.product.variety) + ",")] : _vm._e(), _vm._v("\n        " + _vm._s(_vm.record.product.origin) + ",\n        " + _vm._s(_vm.record.product.unit) + "\n    ")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet"
  }, [_c('h4', [_vm._v("Ceny do publikacji")]), _vm._v(" "), _vm._l((_vm.record.draftPrices), function(price, index) {
    return _c('div', [_c('currency-input', {
      staticClass: "bigger-font",
      nativeOn: {
        "input": function($event) {
          _vm.priceChanged($event)
        }
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab",
      on: {
        "click": function($event) {
          _vm.removeDraftPrice(_vm.record, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.addDraftPrice(_vm.record)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet"
  }, [_c('h4', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Ceny z poprzedniego notowania")]), _vm._v(" "), _vm._l((_vm.record.previousPrices), function(price) {
    return _c('div', [_vm._v("\n      " + _vm._s(_vm._f("currency")(price.price)) + "\n    ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.usePreviousPrices($event)
      }
    }
  }, [_vm._v("\n        Użyj cen z poprzedniego notowania\n    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet"
  }, [_c('h4', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Ceny opublikowane")]), _vm._v(" "), _vm._l((_vm.record.publicPrices), function(price) {
    return _c('div', [_vm._v("\n      " + _vm._s(_vm._f("currency")(price.price)) + "\n    ")])
  })], 2)]) : _c('my-spinner')
},staticRenderFns: []}

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(248),
      "alt": ""
    }
  })])
}]}

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('logo', {
    staticStyle: {
      "text-align": "center"
    }
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "mdl-cell mdl-cell--12-col-phone mdl-cell--6-col-tablet",
    staticStyle: {
      "margin": "0 auto"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('mdl-textfield', {
    staticClass: "mdl-cell mdl-cell--12-col",
    attrs: {
      "label": "Login",
      "autofocus": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('mdl-textfield', {
    staticClass: "mdl-cell mdl-cell--12-col",
    attrs: {
      "label": "Hasło",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-cell mdl-cell--12-col",
    attrs: {
      "primary": "",
      "disabled": _vm.logging
    }
  }, [(_vm.logging) ? [_vm._v("Logowanie...")] : [_vm._v("Zaloguj")]], 2)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout mdl-js-layout mdl-layout--fixed-header"
  }, [_c('header', {
    staticClass: "mdl-layout__header"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_c('mdl-select', {
    attrs: {
      "label": "Dzień",
      "id": "slug-select",
      "value": _vm.slug,
      "options": _vm.days
    },
    on: {
      "input": _vm.goToDay
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation"
  }, [(_vm.card && _vm.thereAreChangedRecordsFor(_vm.card)) ? _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent",
    attrs: {
      "disabled": _vm.offline || _vm.updating
    },
    on: {
      "click": function($event) {
        _vm.updateCard(_vm.card)
      }
    }
  }, [(_vm.offline) ? [_vm._v("offline")] : [(_vm.updating) ? [_vm._v("wysyłam... "), _c('mdl-spinner', {
    attrs: {
      "single-color": ""
    }
  })] : [_vm._v("Wyślij")]]], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout__drawer"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "0 auto",
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.searchFocus),
      expression: "searchFocus"
    }],
    staticClass: "mdl-textfield__input",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "text",
      "id": "sample1",
      "placeholder": "Szukaj..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocus = true
      },
      "blur": function($event) {
        _vm.searchFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search),
      expression: "search"
    }],
    staticStyle: {
      "position": "absolute",
      "right": "2px",
      "top": "2px"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearSearch($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])])]), _vm._v(" "), (_vm.card) ? _c('nav', {
    staticClass: "mdl-navigation"
  }, _vm._l((_vm.filteredCardRecords), function(record) {
    return _c('router-link', {
      key: record.id,
      staticClass: "mdl-navigation__link",
      attrs: {
        "to": _vm.getRouteToEdit(record)
      },
      nativeOn: {
        "click": function($event) {
          _vm.hideMenu($event)
        }
      }
    }, [_c('strong', [(record.changed) ? _c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "color": "#8bc34a"
      }
    }, [_vm._v("edit")]) : _vm._e(), _vm._v("\n          " + _vm._s(record.product.name) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), (record.product.variety) ? [_vm._v(_vm._s(record.product.variety) + ",")] : _vm._e(), _vm._v("\n        " + _vm._s(record.product.origin) + ",\n        " + _vm._s(record.product.unit) + "\n      ")], 2)
  })) : _c('my-spinner')], 1), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "number",
      "onfocus": "this.select()",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.update($event)
      },
      "blur": _vm.update
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mdl-snackbar', {
    attrs: {
      "display-on": "flash"
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    class: {
      'col-sm-4': _vm.horizontal
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: {
      'col-sm-8': _vm.horizontal
    }
  }, [_c('div', {
    class: {
      'input-group': _vm.hasAddon
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasAddon) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_vm._t("addon")], 2) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.card) ? _c('div', [_c('ul', {
    staticClass: "demo-list-three mdl-list"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.card.records), function(record) {
    return _c('li', {
      staticClass: "mdl-list__item mdl-list__item--three-line",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.goToEdit(record)
        }
      }
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('span', [_vm._v(_vm._s(record.product.name))]), _vm._v(" "), _c('span', {
      staticClass: "mdl-list__item-text-body"
    }, [_c('span', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "half"
    }, [(record.product.variety) ? [_vm._v("\n                        " + _vm._s(record.product.variety) + ",\n                      ")] : _vm._e(), _vm._v("\n                      " + _vm._s(record.product.origin) + ",\n                      " + _vm._s(record.product.unit) + "\n                    ")], 2), _vm._v(" "), _c('span', {
      staticClass: "half"
    }, [_c('span', {
      staticClass: "row"
    }, [_c('span', {
      staticClass: "half"
    }, _vm._l((record.publicPrices), function(price) {
      return _c('span', {
        staticStyle: {
          "display": "block"
        }
      }, [_vm._v("\n                              " + _vm._s(_vm._f("currency")(price.price)) + "\n                          ")])
    })), _vm._v(" "), _c('span', {
      staticClass: "half"
    }, _vm._l((record.draftPrices), function(price) {
      return _c('span', {
        staticStyle: {
          "color": "red",
          "display": "block"
        }
      }, [_vm._v("\n                              " + _vm._s(_vm._f("currency")(price.price)) + "\n                          ")])
    }))])])])])]), _vm._v(" "), _vm._m(1, true)])
  })], 2)]) : _c('my-spinner')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "mdl-list__item mdl-list__item--three-line"
  }, [_c('span', {
    staticClass: "mdl-list__item-primary-content"
  }, [_c('span', [_vm._v("Produkt")]), _vm._v(" "), _c('span', {
    staticClass: "mdl-list__item-text-body"
  }, [_c('span', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "half"
  }, [_vm._v("\n                       \n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "half"
  }, [_c('span', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "half"
  }, [_vm._v("\n                          Na stronie\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "half"
  }, [_vm._v("\n                          Wprowadzone\n                        ")])])])])])]), _vm._v(" "), _c('span', {
    staticClass: "mdl-list__item-secondary-content"
  }, [_c('span', {
    staticClass: "mdl-list__item-secondary-action"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mdl-list__item-secondary-content"
  }, [_c('span', {
    staticClass: "mdl-list__item-secondary-action"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])
}]}

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(178);


var _mutations, _actions;








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var addOrUpdateCard = function addOrUpdateCard(state, card, commit) {
  var foundIndex = state.cards.findIndex(function (c) {
    return c.slug === card.slug;
  });
  if (foundIndex > -1) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* UPDATE_CARD */], { index: foundIndex, card: card });
  } else {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ADD_CARD */], card);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    loading: false,
    updating: false,
    cards: []
  },
  getters: {
    thereAreChangedRecordsFor: function thereAreChangedRecordsFor(state) {
      return function (card) {
        return card.records.filter(function (r) {
          return r.changed;
        }).length > 0;
      };
    },
    loading: function loading(state) {
      return state.loading;
    },
    updating: function updating(state) {
      return state.updating;
    },
    getCardBy: function getCardBy(state, getters) {
      return function (slug) {
        return state.cards.find(function (c) {
          return c.slug === slug;
        });
      };
    },
    getRecordBy: function getRecordBy(state, getters) {
      return function (slug, id) {
        var card = getters.getCardBy(slug);
        if (card) {
          return card.records.find(function (r) {
            return r.id === +id;
          });
        }
      };
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SET_PREVIOUS_PRICES */], function (state, _ref) {
    var record = _ref.record,
        previousPrices = _ref.previousPrices;

    record.draftPrices = previousPrices;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* START_LOADING */], function (state) {
    state.loading = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* STOP_LOADING */], function (state) {
    state.loading = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* START_UPDATING */], function (state) {
    state.updating = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* STOP_UPDATING */], function (state) {
    state.updating = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ADD_CARD */], function (state, card) {
    state.cards.push(card);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* UPDATE_CARD */], function (state, _ref2) {
    var index = _ref2.index,
        card = _ref2.card;

    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.cards, index, card);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* ADD_DRAFT_PRICE */], function (state, record) {
    record.draftPrices.push({
      price: '0.00'
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* REMOVE_DRAFT_PRICE */], function (state, _ref3) {
    var record = _ref3.record,
        index = _ref3.index;

    record.draftPrices.splice(index, 1);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* RECORD_CHANGED */], function (state, record) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(record, 'changed', true);
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["a" /* FETCH_CARD */], function (_ref4, slug) {
    var commit = _ref4.commit,
        state = _ref4.state;

    __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].card.getItem(slug).then(function (_ref5) {
      var body = _ref5.body;

      addOrUpdateCard(state, body, commit);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["b" /* UPDATE_CARD */], function (_ref6, card) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var data = {};
    data.records = card.records.map(function (r) {
      return {
        id: r.id,
        draftPrices: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* filterZeroPrices */])(r.draftPrices)
      };
    });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* START_UPDATING */]);
    return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].card.updateItem(card.slug, data).then(function (_ref7) {
      var body = _ref7.body;

      addOrUpdateCard(state, body, commit);
    }).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* STOP_UPDATING */]);
    });
  }), _actions)
}));

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_CARD; });
var FETCH_CARD = 'FETCH_CARD';
var UPDATE_CARD = 'UPDATE_CARD';

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  card: {
    getItem: function getItem(slug) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('api/cards/' + slug + '?with=previous-prices');
    },
    updateItem: function updateItem(slug, data) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('api/cards/' + slug, data);
    },
    publish: function publish(id) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('api/cards/' + id + '/publish');
    }
  },
  record: {
    update: function update(id, record) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put('api/records/' + id, record);
    },
    get: function get(id, success, error) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('api/records/' + id).then(success, error);
    }
  },
  auth: {
    login: function login(username, password) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('api/login_check', {
        _username: username,
        _password: password
      });
    }
  }
});

/***/ })

},[179]);


// WEBPACK FOOTER //
// static/js/app.e33814bfc8a936ae88da.js